import * as React from "react";
import { AiOutlineBtn } from "./components/ui/AiOutlineBtn";
import type { ConfirmAction } from "./types";

export type InlineConfirmBarProps = {
  action: ConfirmAction;
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export const InlineConfirmBar: React.FC<InlineConfirmBarProps> = ({
  action,
  count,
  onConfirm,
  onCancel,
}) => {
  if (!action) return null;

  const label =
    action === "accept"
      ? `Accept all ${count} suggestion${count === 1 ? "" : "s"}?`
      : `Reject all ${count} suggestion${count === 1 ? "" : "s"}?`;

  return (
    <div className="ai-analysis__confirm-bar" role="status">
      <span>{label}</span>
      <div className="ai-analysis__confirm-actions">
        <AiOutlineBtn primary onClick={onConfirm}>
          {action === "accept" ? "Yes, accept all" : "Yes, reject all"}
        </AiOutlineBtn>
        <AiOutlineBtn onClick={onCancel}>Cancel</AiOutlineBtn>
      </div>
    </div>
  );
};
